import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/pricing/components/PricingOfferButton.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/hospitality/hotel1.png");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/CookiePreferences.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/Disclosure.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/Experience.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/HeroAwards.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/HeroVideo.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/HomeAwards.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/components/AeoContent.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/IntroVideo.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/Message.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/ProductVisual.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/SeoContent.module.scss");
